<template>
  <div class="wlx-text-book-wrapper">
    <div class="pc-text-book-show">
      <div class="text-book-center">
        <div class="text-book-center-search" style="margin-top: 15px;">
          <span>教材搜索：</span>
          <el-input placeholder="请输入书名/ISBN/作者" v-model="textBookName" style="width: 60%">
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-button type="primary" style="margin-left: 10px;" @click="getTextBookList()">搜索</el-button>
        </div>
        <div class="text-book-center-publishBooks">
          <div class="choose-publishBooks-time">
            <span>出版时间：</span>
            <span
              style="margin-left: 20px;"
              @click="getFullYear"
              :class="{'yearActive' : yearShowActive == true}"
            >全部</span>
            <span
              v-for="(item,index) in timeList"
              :key="index"
              style="margin-left: 26px;"
              @click="getYear(index,item)"
              :class="{'yearActive' : yearIndexShowActive == index}"
            >{{item}}年</span>
            <span
              style="margin-left: 26px;"
              @click="getEndYear"
              :class="{'yearActive' : endYearShowActive == true}"
            >{{endYear}}年以前</span>
          </div>
          <div class="publishBooks-list clearfix">
            <div
              class="publishBooks-list-container"
              v-for="(item,index) in booksInfoList"
              :key="index"
              @click="getTeaching(item.Id)">
              <div class="publishBooks-list-img">
                <img :src="item.BookCover" style="width: 100%" />
              </div>
              <div class="publishBooks-list-info">
                <h3 class="info-books-name">{{item.Title}}</h3>
                <p class="info-books-author">
                  <span style="margin-right: 7px;">作者：</span>
                  <span>{{item.Author}}</span>
                  <span style="margin-left: 35px;margin-right: 7px;">出版时间：</span>
                  <span>{{item.IssueDate}}</span>
                </p>
                <p class="info-books-author">
                  <span style="margin-right:">ISBN：</span>
                  <span>{{item.ISBN}}</span>
                </p>
                <p class="info-books-author">图书简介：</p>
                <p class="info-books-introduce">{{item.TextBookBrief}}</p>
              </div>
            </div>
          </div>
          <div class="publishBooks-list-pagination" style>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 移动端 -->
    <div class="ph-text-book-show">
      <div class="crumbs-text">
        <div style="padding:0 20px;">
          <i class="wl-icon-zhuye1"></i>
          <span @click="goHome" style="cursor: pointer;">首页</span>
          <span>></span>
          <span>教材中心</span>
        </div>
      </div>
      <div class="search-book-con">
        <el-input
          placeholder="请输入书名/ISBN/作者"
          size="mini"
          v-model="textBookName"
          class="search-book-input"
        >
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="primary" size="mini" @click="getTextBookList()">搜索</el-button>
      </div>
      <v-refresh :on-refresh="onRefresh">
        <v-reload
          :on-infinite-load="onInfiniteLoad"
          :parent-pull-up-state="infiniteLoadData.pullUpState"
        >
          <div
            v-for="(item,index) in phBookData"
            :key="index"
            class="ph-book-child-con clearfix"
            @click="getTeaching(item.Id)"
          >
            <div class="fl text-book-img-con">
              <img :src="item.BookCover" />
            </div>
            <div class="fr text-book-info-con">
              <h4 class="u-label-con">{{item.Title}}</h4>
              <p class="u-label-con">
                <span>作者：</span>
                <span>{{item.Author}}</span>
              </p>
              <p class="u-label-con">
                <span>出版时间：</span>
                <span>{{item.IssueDate}}</span>
              </p>
              <p class="u-label-con">
                <span style="margin-right:">ISBN：</span>
                <span>{{item.ISBN}}</span>
              </p>
              <p class="u-label-con">图书简介：</p>
              <p class="p-book-intro-con">{{item.TextBookBrief}}</p>
            </div>
          </div>
        </v-reload>
      </v-refresh>
    </div>
  </div>
</template>

<script>
import downFresh from "components/refreshData/downFresh.vue";
import pullUpReload from "components/refreshData/pullUpReload.vue";
export default {
  data() {
    return {
      textBookName: "",
      BookCenterBg: require("../../assets/images/textBookCenter.png"),
      categoryShowActive: true,
      categoryIndexActive: -1,
      timeList: [],
      booksInfoList: [],
      endYear: "",
      yearShowActive: true,
      endYearShowActive: false,
      yearIndexShowActive: -1,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      year: "",
      isBefor: "0",
      index: "clppx",
      infiniteLoadData: {
        initialShowNum: 3, // 初始显示多少条
        everyLoadingNum: 3, // 每次加载的个数
        pullUpState: 0, // 子组件的pullUpState状态
        pullUpList: [], // 上拉加载更多数据的数组
        showPullUpListLength: this.initialShowNum // 上拉加载后所展示的个数
      },
      phBookData:[]
    };
  },
  components: {
    "v-refresh": downFresh,
    "v-reload": pullUpReload
  },
  created() {
    // debugger;
    
    this.getTextBookList();
    this.getCurrentYear();
  },
  methods: {
    onRefresh(done) {
      this.phBookData = [];
      this.getTextBookList();
      done();
    },
    onInfiniteLoad(done) {
      this.seeMoreBookList();
      done();
    },
    seeMoreBookList() {
      this.pageSize = this.pageSize + 3;
      this.getTextBookList();
    },
    getCurrentYear() {
      let newDate = new Date();
      let currentYear = newDate.getFullYear();
      for (let i = 0; i < 8; i++) {
        this.timeList.push(currentYear - i);
      }
      this.endYear = this.timeList[this.timeList.length - 1];
    },
    canael() {
      this.isBefor = "0";
      this.year = "";
    },
    //获取教材
    getTextBookList() {
      var that = this;
      this.$http
        .post("/api/XOrg/TextBook/getTextBookList", {
          index: this.index,
          IssueDate: this.year,
          textBookName: this.textBookName,
          isBefor: this.isBefor,
          page: this.currentPage,
			  	pageSize: this.pageSize
        })
        .then(rst => {
          if (rst.code > 0) {
            that.booksInfoList = rst.list;
            that.currentPage = rst.pagination.pageIndex;
            that.total = rst.pagination.totalCount;
            that.phBookData = rst.list;
            if (that.phBookData.length == that.total) {
              that.infiniteLoadData.pullUpState = 3;
            }else if (that.phBookData.length < that.total) {
              that.infiniteLoadData.pullUpState = 2;
            }else {
               that.infiniteLoadData.pullUpState = 1;
            }
            that.canael();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    goHome() {
      this.$router.push({
        name: "xHome"
      });
    },
    // 分页处理
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTextBookList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTextBookList();
    },
    getTeaching(id) {
      this.$router.push({
        name: "teachingDetails",
        params: {
          bookId: id
        }
      });
    },
    // 全部年份
    getFullYear() {
      this.yearShowActive = true;
      this.endYearShowActive = false;
      this.yearIndexShowActive = -1;
      this.getTextBookList();
    },
    // 选择其他年份
    getYear(index, time) {
      this.isBefor = "0";
      // console.log(index);
      this.year = time + "-" + "01" + "-" + "01";
      console.log(this.year);
      this.yearShowActive = false;
      this.endYearShowActive = false;
      this.yearIndexShowActive = index;
      this.getTextBookList();
    },
    // 获取末尾年份之前
    getEndYear() {
      this.endYearShowActive = true;
      this.yearShowActive = false;
      this.yearIndexShowActive = -1;
      this.year = this.endYear + "-" + "01" + "-" + "01";
      this.isBefor = "1";
      this.getTextBookList();
    }
  }
};
</script>

<style lang="scss" scoped>
.text-book-center-bg {
  width: 100%;
  height: 400px;
}
.text-book-center {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  // border: 1px solid #2d82ff;
  .text-book-center-header {
    width: 1200px;
    margin: 0 auto;
    line-height: 47px;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
    .textcenter-mooc-home:hover {
      color: #2d82ff;
    }
  }
  .text-book-center-search {
    width: 1200px;
    height: 60px;
    line-height: 60px;
    background: #fff;
    margin: 0 auto;
    text-align: center;
  }
  .text-book-center-category {
    width: 1200px;
    height: 158px;
    background: #fff;
    margin-top: 30px;
    text-align: center;
    .category-left {
      width: 110px;
      height: 158px;
      line-height: 50px;
      // border: 1px solid #2d82ff;
    }
    .category-middle {
      width: 30px;
      height: 158px;
      line-height: 50px;
      cursor: pointer;
      // border: 1px solid #2d82ff;
    }
    .category-right {
      width: 1060px;
      height: 158px;
      line-height: 50px;
      cursor: pointer;
      p {
        text-align: left;
        width: 160px;
        margin-left: 15px;
        font-size: 15px;
        font-weight: 400;
      }
    }
    .categoryActive {
      color: #2d82ff;
    }
  }
  .text-book-center-publishBooks {
    width: 1200px;
    // height:1335px;
    margin-top: 30px;
    margin-bottom: 50px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(223, 226, 230, 1);
    box-shadow: 0px 3px 2px 0px rgba(0, 0, 0, 0.08);
    .choose-publishBooks-time {
      width: 1181px;
      height: 60px;
      line-height: 60px;
      margin: 0 auto;
      padding-left: 19px;
      border-bottom: 1px solid #dfe2e6;
      cursor: pointer;
      span:nth-child(1) {
        cursor: auto;
      }
      .yearActive {
        color: #2d82ff;
      }
    }
    .publishBooks-list {
      width: 1200px;
      .publishBooks-list-container {
        float: left;
        margin: 20px 0 0 34px;
        width: 550px;
        height: 270px;
        cursor: pointer;
        // border: 1px solid #2d82ff;
        .publishBooks-list-img {
          float: left;
          margin: 22px 0 0 20px;
          width: 150px;
          height: 200px;
          overflow: hidden;
          border: 1px solid #dfe2e6;
          padding: 10px 0;
          background: #fff;
        }
        .publishBooks-list-info {
          float: right;
          margin-top: 22px;
          padding-left: 25px;
          padding-right: 25px;
          width: 326px;
          .info-books-name {
            margin-top: 4px;
            color: #333;
            font-size: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .info-books-author {
            margin-top: 20px;
            color: #666;
            font-size: 14px;
          }
          .info-books-introduce {
            margin-top: 10px;
            line-height: 1.5;
            max-height: 65px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          }
        }
      }
      .publishBooks-list-container:hover {
        background: #e9ecf0;
      }
    }
    .publishBooks-list-pagination {
      padding: 20px 0;
      text-align: center;
    }
  }
}
</style>

